<template>
	<v-content-layout>
		<v-alert v-if="alert.show" type="success">
			Great! Your file was now successfully uploaded. Here is your Batch ID:
			<strong>{{ alert.message }}</strong>
		</v-alert>

		<template #header>
			<FilterOption />
			<div>
				<el-input size="small" class="ml-2" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
			</div>
			<v-spacer></v-spacer>
			<v-export-table text="Export" :tableColumns="setTableColumns" :tableData="setTableData" :filename="`Upload-List-${Date.now()}`" :filesheet="`Upload-List`" />
		</template>

		<template #body>
			<e-table :data="items" :total="items.length" :headers="headers" :height="window.height - 185" :search="search" :loading="loading">
				<template #actions="{scope}">
					<el-button v-tooltip.top="'View Parsed Result'" size="mini" type="danger" icon="el-icon-view" @click="viewParsedResult(scope.row)"></el-button>
					<el-button v-tooltip.top="'Download'" size="mini" type="warning" icon="el-icon-download" @click="$downloadFile(`${scope.row.brandname}-${scope.row.batchId}.xlsx`, scope.row.fileLink)"></el-button>
				</template>

				<template #footer>
					<el-button size="small" type="danger" icon="mdi mdi-filter-remove" @click="clearFilter"> Clear Filter</el-button>
					<el-button size="small" type="primary" icon="mdi mdi-refresh" @click="loadUploadHistory"> Reload</el-button>
				</template>
			</e-table>
		</template>
	</v-content-layout>
</template>

<script>
import FilterOption from './components/FIlterOption';
import { state } from '@/store/store';
import { mapGetters, mapActions } from 'vuex';
import * as type from '@/store/types';
import { bus } from '@/main';

export default {
	components: { FilterOption },
	data: () => ({
		search: '',
		uploadTemplateItems: [],
		alert: {
			show: false,
			message: ''
		}
	}),
	computed: {
		...mapGetters({
			headers: 'uploadhistory/headers',
			items: 'uploadhistory/items',
			loading: 'global/loading',
		}),
		setTableColumns() {
			return this.headers.map(e => {
				return{ label: e.text, field: e.value }
			})
		},
		setTableData(){
			return this.items.map(e => {
				let status = e.status == 1 ? "Parsed" : "Added to Records"
				return { ...e, status }
			})
		}
	},
	created() {
		this.loadUploadHistory({});
		
		if (this.$route.query.batchId) {
			this.alert = {
				show: true,
				message: this.$route.query.batchId,
			};
		}
	},
	methods: {
		...mapActions({
			loadUploadHistory: `uploadhistory/${type.GET_UPLOAD_HISTORY}`,
			viewParsedResult: `uploadhistory/${type.VIEW_PARSED_RESULT}`,
		}),
		clearFilter(){
			bus.$emit('clearUploadHistoryFilter')
			this.loadUploadHistory({});
		},
	}
	
};
</script>
